import React from 'react'

export default function Hero() {
  return (
    <div>Company Section</div>
  )
}
